import './index.scss'
import { Dropdown, MenuProps } from 'antd'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import QaIcon from '@/assets/qa-icon.webp'
import { Agreement } from '@/assets/svg/agreement'
import { Study } from '@/assets/svg/study'
import { Video } from '@/assets/svg/video'
import { UserStore } from '@/global-states'
import { eventTracking, urlSource } from '@/libs/util'
import {
  CaretDownOutlined,
  FilePptFilled,
  MessageFilled,
  ProjectFilled,
  QuestionCircleFilled,
  QuestionCircleOutlined,
  SoundFilled
} from '@ant-design/icons'
import CreationShare from '../CreationShare'
import QaModal from '../QaModal'
import VideoModal from '../VideoModal'

const CustomerService: FC = () => {
  const { t: translate } = useTranslation(['customer_service'])
  const [open, setOpen] = useState(false)
  const [qaModalOpen, setQaModalOpen] = useState<any>()
  const [creationShareOpen, setCreationShareOpen] = useState(false)
  const [preview, setPreview] = useState<any>()
  const { userPackage, showQuestion, showQuestionModal, versionNumber } = UserStore

  useEffect(() => {
    if (UserStore.getToken() && !location.href.includes('login')) {
      getQaCompleted()
    }
  }, [])

  const getQaCompleted = async () => {
    UserStore.getQaCompleted()
  }

  const readNew = () => {
    if (versionNumber > 0) {
      UserStore.versionNumber = versionNumber - 1
      localStorage.setItem('version-20250409', `${versionNumber - 1}`)
    }
  }

  const items: MenuProps['items'] = [
    {
      label: translate('customer_service.beginner_guide'),
      key: '0',
      icon: <Video />
    },
    {
      label: (
        <a
          target="_blank"
          rel="noreferrer"
          href="https://lingverse.feishu.cn/wiki/KnllwUb9diAeyYkPsoqcYwMAnvc?fromScene=spaceOverview"
          onClick={readNew}
        >
          {translate('customer_service.feature_updates')}
          {versionNumber > 0 && <i className="tip"></i>}
        </a>
      ),
      key: '5',
      icon: <SoundFilled />
    },
    {
      label: (
        <a target="_blank" rel="noreferrer" href="https://lingverse.feishu.cn/docx/FPIwdnsV1o3RcexqwuHcpit7n2g">
          {translate('customer_service.user_manual')}
        </a>
      ),
      key: '1',
      icon: <Agreement />
    },
    {
      label: (
        <a target="_blank" rel="noreferrer" href={`/study/index.html?v=${Date.now()}`}>
          {translate('customer_service.study_center')}
        </a>
      ),
      key: 'study',
      icon: <Study className="customer-study" />
    },
    {
      label: translate('customer_service.case_sharing'),
      key: 'case',
      icon: <FilePptFilled />
    },
    {
      label: (
        <a
          target="_blank"
          rel="noreferrer"
          href="https://lingverse.feishu.cn/docx/VxnydIE4ao5NCyx7fnycqPX7npd?fromScene=spaceOverview&create_from=create_doc_to_wiki&302from=wiki"
        >
          {translate('customer_service.faq')}
        </a>
      ),
      key: '2',
      icon: <QuestionCircleFilled />
    },
    {
      label: (
        <a
          target="_blank"
          rel="noreferrer"
          href="https://lingverse.feishu.cn/share/base/form/shrcn0blCe32lckLKET1LHnBmVf"
        >
          {translate('customer_service.feedback')}
        </a>
      ),
      key: '3',
      icon: <MessageFilled />
    },
    {
      label: (
        <a
          target="_blank"
          rel="noreferrer"
          href="https://lingverse.feishu.cn/share/base/form/shrcnWRuabfQiUQh4wG1ghZ9gzf"
        >
          {translate('customer_service.invoice_request')}
        </a>
      ),
      key: '4',
      icon: <ProjectFilled />
    },
    {
      label: (
        <div className="menu-qrcode">
          <img
            src={urlSource(
              userPackage?.membership_expire_time && !userPackage?.membership_expired
                ? `hiflys/qrcode/qrcode-vip-new.png?v=${Date.now()}`
                : `hiflys/qrcode/qrcode-new.png?v=${Date.now()}`
            )}
          />
          <div className="desc">{translate('customer_service.add_wechat_prompt')}</div>
        </div>
      ),
      key: '6'
    }
  ]

  const onItemClick: MenuProps['onClick'] = ({ key }) => {
    if (key === '0') {
      eventTracking('BeginnerGuide')
      setPreview({
        url: urlSource('hiflys/新手引导.mp4'),
        title: translate('customer_service.beginner_guide')
      })
    }

    if (key === 'case') {
      setCreationShareOpen(true)
    }

    if (key === '1') {
      eventTracking('UserManual')
    }
  }

  const onQaModalClose = () => {
    setQaModalOpen(false)
    localStorage.setItem('qaModal', '1')
  }

  if (location.href.includes('mobile')) return null

  return (
    <>
      {showQuestion && (
        <div className="qa-icon" onClick={() => setQaModalOpen(true)}>
          <img src={QaIcon} />
        </div>
      )}

      <Dropdown
        menu={{ items, onClick: onItemClick }}
        placement="topRight"
        overlayClassName="customer-dropdown"
        trigger={['click']}
        open={open}
        onOpenChange={(open) => {
          if (open) {
            eventTracking('HelpCenter')
          }
          setOpen(open)
        }}
      >
        <div className="customer-service" onClick={(e) => e.preventDefault()}>
          {open ? <CaretDownOutlined /> : <QuestionCircleOutlined />}
          {versionNumber > 0 && <i className="vesion-new">1</i>}
        </div>
      </Dropdown>

      <VideoModal preview={preview} onCancel={() => setPreview(undefined)} />

      <QaModal open={qaModalOpen} onCancel={onQaModalClose} onSuccess={getQaCompleted} />

      <CreationShare open={creationShareOpen} onCancel={() => setCreationShareOpen(false)} />
    </>
  )
}

export default CustomerService
